import { useEffect } from 'react';
import api from '../utils/api';

/** Keeps the Admin "Who is using" list fresh while a tab stays open. */
const PresenceHeartbeat = () => {
  useEffect(() => {
    if (!localStorage.getItem('token')) return undefined;
    const beat = () => api.post('/auth/presence/').catch(() => {});
    beat();
    const t = setInterval(beat, 2 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  return null;
};

export default PresenceHeartbeat;
